export default "__VITE_ASSET__NjEZ7AIw__"